import customFetch from './customFetch';

export const isLoggedIn = () => (
  customFetch('/api/1/accounts')
);

// TODO: This call will not be necessary when all endpoints are connected
export const checkPermissions = () => (
  customFetch('/hero-banners')
);
